<template>
      <div class="overlay-wrap white active">
    <!-- <div class="loadingio-spinner-spinner-acmdkw9v8mu"><div class="ldio-xysc4s9ys08">
<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
</div></div> -->
    <div class="wrapLoading loadingio-spinner-spinner-acmdkw9v8mu">
      <img src="../assets/images/LogoPerindo.png" alt="" width="100%">
      <div class="loadingBar">
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.overlay-wrap.white{
    background-color: #fff;
    z-index: 99999;
}
 .loadingio-spinner-spinner-acmdkw9v8mu {
    width: 170px;
    height: 200px;
    display: inline-block;
    overflow: hidden;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    img{
        margin-bottom: 2rem;
        width: 100%;
    }
    /* background: #ffffff; */
    .loadingBar{
        height: 10px;
        border-radius: 10px;
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: darkgray;
  background: linear-gradient(to right, #21409a80  10%, $blue 18%, #eeeeee 33%);
  background-size: 1500px 104px;
  // height: 100px;
  position: relative;
    }
  }
</style>
